interface BrandMarkProps {
  /** Rendered HEIGHT of the logo in px (width scales to the art's aspect ratio). */
  size?: number;
  subtitle?: string;
  /** Accepted for backwards compatibility; the logo art already includes the wordmark. */
  withWordmark?: boolean;
}

/**
 * The ClovaScribe logo. The art at /logo.png is a wide (~3:1) wordmark lockup,
 * so it is sized by HEIGHT with an automatic width — forcing it into a square
 * box (the old behaviour) crushed it to a few pixels tall. The art already
 * contains the "ClovaScribe" wordmark, so no separate text is rendered.
 */
export function BrandMark({ size = 32, subtitle }: BrandMarkProps) {
  return (
    <div className="col" style={{ alignItems: "flex-start", gap: 4 }}>
      <img
        src="/logo.png"
        alt="ClovaScribe"
        style={{
          height: size,
          width: "auto",
          display: "block",
          objectFit: "contain",
          filter: "drop-shadow(0 2px 8px rgba(45,212,191,0.3))"
        }}
      />
      {subtitle && (
        <span style={{ fontSize: 12, color: "var(--text-faint)", letterSpacing: "0.04em" }}>
          {subtitle}
        </span>
      )}
    </div>
  );
}
